import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import { date, showAlert, regexNumericDecimalOne } from '../../../lib/helpers';
import { headers, search, defaultItem, editedItem, dataListMccMdrStatus, dataCategoryMccMdr } from './attributes';

export default {
  validations: {
    editedItem: {
      mcc: {
        required,
        numeric,
        maxLength: maxLength(4),
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mcc == null ||
              this.errorValidation.mcc.length < 1)
          );
        },
      },
      description: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.description == null ||
              this.errorValidation.description.length < 1)
          );
        },
      },
      category_id: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.category_id == null ||
              this.errorValidation.category_id.length < 1)
          );
        },
      },
      mcc_name: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mcc_name == null ||
              this.errorValidation.mcc_name.length < 1)
          );
        },
      },
      mdr_on_us: {
        required,
        numericDecimal: regexNumericDecimalOne,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mdr_on_us == null ||
              this.errorValidation.mdr_on_us.length < 1)
          );
        },
      },
      mdr_off_us: {
        required,
        numericDecimal: regexNumericDecimalOne,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mdr_off_us == null ||
              this.errorValidation.mdr_off_us.length < 1)
          );
        },
      },
      status: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.status == null ||
              this.errorValidation.status.length < 1)
          );
        },
      },
    },
  },

  data: () => ({
    options: {},
    view: false,
    dialog: false,
    dialogView: false,
    dialogDelete: false,
    show: false,
    editedIndex: -1,
    headers,
    defaultItem,
    search,
    editedItem,
    selectedRow: '',
    listMccMdrStatus: dataListMccMdrStatus,
    dateFormatted: '',
    updateFormatted: '',
    dateMenu: false,
    updateMenu: false,
    allCategory: dataCategoryMccMdr,
    filterData: [
      { label: 'Kode MCC', field: 'mcc', type: 'text' },
      { label: '', field: 'empty_1', type: '' },
      { label: 'Jenis Usaha', field: 'mcc_name', type: 'text' },
      { label: '', field: 'empty_2', type: '' },
      { label: '', field: 'empty_3', type: '' },
      { label: 'Created At', field: 'created_at', type: 'date' },
      { label: 'Updated At', field: 'updated_at', type: 'date' },
      { label: 'Status', field: 'status', type: 'select', items: dataListMccMdrStatus },
      { label: '', field: 'empty_4', type: '' },
    ],
  }),

  computed: {
    allData() {
      return this.$store.state.settingFee.mccmdr.allData;
    },
    totalData() {
      return this.$store.state.settingFee.mccmdr.totalData;
    },
    totalPage() {
      return this.$store.state.settingFee.mccmdr.totalPage;
    },
    loading() {
      return this.$store.state.settingFee.mccmdr.loading;
    },
    formTitle() {
      let item = '';
      if (this.editedIndex !== -1) {
        if (this.editedIndex === -2) item = 'View Item';
        else item = 'Edit Item';
      } else item = 'New Item';
      return item;
    },
    flashError: {
      get() {
        return this.$store.state.settingFee.mccmdr.flashError;
      },
      set() {
        this.$store.commit('settingFee/mccmdr/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.settingFee.mccmdr.flashErrorMessage;
    },
    errorValidation() {
      return this.$store.state.settingFee.mccmdr.errors;
    },
    mccCodeErrors() {
      const errors = [];
      if (!this.$v.editedItem.mcc.$dirty) return errors;
      if (!this.$v.editedItem.mcc.required) errors.push('Kode MCC is required');
      if (!this.$v.editedItem.mcc.numeric)
        errors.push('Kode MCC is numeric only');
      if (!this.$v.editedItem.mcc.maxLength)
        errors.push('Kode MCC must less than 5 digit');
      if (!this.$v.editedItem.mcc.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.mcc != null
        ) {
          this.errorValidation.mcc.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.editedItem.description.$dirty) return errors;
      if (!this.$v.editedItem.description.required)
        errors.push('Deskripsi is required');
      if (!this.$v.editedItem.description.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.description != null
        ) {
          this.errorValidation.description.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mccCategoryErrors() {
      const errors = [];
      if (!this.$v.editedItem.category_id.$dirty) return errors;
      if (!this.$v.editedItem.category_id.required)
        errors.push('Kategori MCC is required');
      if (!this.$v.editedItem.category_id.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.category_id != null
        ) {
          this.errorValidation.category_id.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    jenisUsahaErrors() {
      const errors = [];
      if (!this.$v.editedItem.mcc_name.$dirty) return errors;
      if (!this.$v.editedItem.mcc_name.required)
        errors.push('Jenis Usaha is required');
      if (!this.$v.editedItem.mcc_name.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.mcc_name != null
        ) {
          this.errorValidation.mcc_name.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdrOnUsErrors() {
      const errors = [];
      if (!this.$v.editedItem.mdr_on_us.$dirty) return errors;
      if (!this.$v.editedItem.mdr_on_us.required)
        errors.push('MDR On Us is required');
      if (!this.$v.editedItem.mdr_on_us.numericDecimal)
        errors.push('MDR On Us is numeric only');
      if (!this.$v.editedItem.mdr_on_us.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.mdr_on_us != null
        ) {
          this.errorValidation.mdr_on_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdrOffUsErrors() {
      const errors = [];
      if (!this.$v.editedItem.mdr_off_us.$dirty) return errors;
      if (!this.$v.editedItem.mdr_off_us.required)
        errors.push('MDR Off Us is required');
      if (!this.$v.editedItem.mdr_off_us.numericDecimal)
        errors.push('MDR Off Us is numeric only');
      if (!this.$v.editedItem.mdr_off_us.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.mdr_off_us != null
        ) {
          this.errorValidation.mdr_off_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.editedItem.status.$dirty) return errors;
      if (!this.$v.editedItem.status.required)
        errors.push('Status is required');
      if (!this.$v.editedItem.status.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.status != null
        ) {
          this.errorValidation.status.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },
    'search.updated_at': {
      handler() {
        this.updateFormatted = this.formatDate(this.search.updated_at);
        this.getData();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },

    'editedItem.mcc': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.mcc != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'mcc');
          }
        }
      },
    },

    'editedItem.description': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.description != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'description');
          }
        }
      },
    },

    'editedItem.category_id': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.category_id != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'category_id');
          }
        }
      },
    },

    'editedItem.mcc_name': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.mcc_name != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'mcc_name');
          }
        }
      },
    },

    'editedItem.mdr_on_us': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.mdr_on_us != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'mdr_on_us');
          }
        }
      },
    },

    'editedItem.mdr_off_us': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.mdr_off_us != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'mdr_off_us');
          }
        }
      },
    },

    'editedItem.status': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.status != null) {
            this.$store.commit('settingFee/mccmdr/clearErrorVariable', 'status');
          }
        }
      },
    },
  },

  async mounted() {
    this.getRoles();
  },

  methods: {
    extractErrorMessage(responseData, defaultMessage) {
      if (!responseData) return defaultMessage;

      const { data, messageEn } = responseData;

      if (typeof data === 'string' && data.trim()) {
        return data;
      }

      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const hasFieldErrors = Object.keys(data).some(
          (field) => Array.isArray(data[field]) && data[field].length > 0
        );
        if (hasFieldErrors) {
          return defaultMessage;
        }
      }

      return messageEn || defaultMessage;
    },
    handleFieldErrors(responseData) {
      if (!responseData) return;

      const { data } = responseData;

      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        this.$store.commit('settingFee/mccmdr/setErrors', data);
      }
    },
    getStatusLabel(status) {
      if (status === '0') return 'Inactive';
      if (status === '1') return 'Active';
      return '-';
    },
    addItem() {
      this.dialog = true;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    resetUniqueValidation() {
      this.$store.commit('settingFee/mccmdr/clearErrors');
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.dialogView = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    getRoles() {
      this.$store.dispatch('settingFee/mccmdr/fetchAllCategory');
    },

    getData() {
      this.$store.commit('settingFee/mccmdr/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('settingFee/mccmdr/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    async save() {
      this.$store.commit('settingFee/mccmdr/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = this.editedItem;
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('settingFee/mccmdr/updateData', {
              date,
              body: data,
              index: this.editedIndex,
            })
            .then((result) => {
              if (result && result.success) {
                showAlert(
                  this.$store,
                  'Update mcc mdr success !',
                  'mdi-check-circle',
                  'green'
                );
                this.close();
                this.getData();
              } else if (result?.code === 302) {
                this.handleFieldErrors(result);
              } else {
                this.handleFieldErrors(result);
                const errorMessage = this.extractErrorMessage(
                  result,
                  'Error on update mcc mdr !'
                );
                showAlert(
                  this.$store,
                  errorMessage,
                  'mdi-alert',
                  'red'
                );
              }
            });
        } else {
          await this.$store
            .dispatch('settingFee/mccmdr/createData', {
              date,
              value: this.editedItem,
            })
            .then((result) => {
              if (result && result.success) {
                showAlert(
                  this.$store,
                  'Create mcc mdr success !',
                  'mdi-check-circle',
                  'green'
                );
                this.close();
                this.getData();
              } else if (result?.code === 302) {
                this.handleFieldErrors(result);
              } else {
                this.handleFieldErrors(result);
                const errorMessage = this.extractErrorMessage(
                  result,
                  'Error on create mcc mdr !'
                );
                showAlert(
                  this.$store,
                  errorMessage,
                  'mdi-alert',
                  'red'
                );
              }
            });
        }
      }
    },

    closeFlash() {
      this.$store.commit('settingFee/mccmdr/setFlashErrorMessage', '');
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    viewItem(item) {
      const newItem = { ...item, data: { mcc: item.mcc } };
      this.editedIndex =
        this.$store.state.settingFee.mccmdr.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.view = true;
      this.editedIndex = -2;
      this.dialogView = true;
    },

    editItem(item) {
      this.view = false;
      const newItem = { ...item, data: { id: item.id } };
      this.editedIndex =
        this.$store.state.settingFee.mccmdr.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    deleteItem(item) {
      const newItem = { ...item, data: { mcc: item.mcc } };
      this.editedIndex =
        this.$store.state.settingFee.mccmdr.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('settingFee/mccmdr/deleteData', {
          date,
          body: this.editedItem,
          index: this.editedIndex,
        })
        .then((status) => {
          if (status) {
            showAlert(
              this.$store,
              'Deactive success !',
              'mdi-check-circle',
              'green'
            );
            this.closeDelete();
          }
        });
    },

    clearSearch() {
      this.search.mcc = '';
      this.search.category_id = '';
      this.search.mcc_name = '';
      this.search.mdr_on_us = '';
      this.search.mdr_off_us = '';
      this.search.status = '';
      this.search.created_at = null;
      this.search.updated_at = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    textStatus(status) {
      const index = this.listMccMdrStatus.find((val) => val.value === status);
      return index.text;
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};